export default __webpack_public_path__ + "static/media/info-icon.248ac92a.svg";